import PropTypes from 'prop-types';
import UserProp from '../../../commonComponents/propTypes/userProp';
import ImageProp from '../../../commonComponents/propTypes/imageProp';
import AddressProp from '../../../commonComponents/forms/Address/AddressProp';
import CountryProp from '../../../commonComponents/forms/Address/CountryProp';
import HardSkillProp from './hardSkillProp';

const propType = {
  _id: PropTypes.string,
  game: PropTypes.string,
  referencedBy: PropTypes.oneOfType([
    PropTypes.shape(UserProp.propType),
    PropTypes.string,
  ]),
  firstName: PropTypes.string,
  lastName: PropTypes.string,
  image: PropTypes.shape(ImageProp.propType),
  email: PropTypes.string,
  phone: PropTypes.string,
  address: PropTypes.shape(AddressProp.propType),
  nationality: PropTypes.shape(CountryProp.propType),
  birthday: PropTypes.number,
  genre: PropTypes.oneOf(['male', 'female']),
  softSkills: PropTypes.shape({
    experienceTime: PropTypes.number,
    experienceDomain: PropTypes.arrayOf(PropTypes.string),
    languages: PropTypes.arrayOf(PropTypes.shape(CountryProp.propType)),
  }),
  hardSkills: PropTypes.arrayOf(PropTypes.shape(HardSkillProp.propType)),
};

export default { propType };
